// actions/employee-onboarding/receipt.js

import { attachAuth } from '../../utils/authService';

export function receiptHasErrored(bool) {
  return {
    type: 'ONBOARDING_RECEIPT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function receiptIsLoading(bool) {
  return {
    type: 'ONBOARDING_RECEIPT_IS_LOADING',
    isLoading: bool
  };
}

export function receiptFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_RECEIPT_FETCH_DATA_SUCCESS',
    data
  };
}

export function receiptFetchData(host, params) {
  return (dispatch) => {
    dispatch(receiptIsLoading(true));
    dispatch(receiptHasErrored(false));
    fetch(host + 'approve/receipt', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(receiptFetchDataSuccess(result));
            dispatch(receiptHasErrored(false));
            dispatch(receiptIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(receiptHasErrored(true));
            dispatch(receiptIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(receiptHasErrored(true));
      dispatch(receiptIsLoading(false));
    });
  };
}